import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class DataLockGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();		
		
		var dataLockGrid = this;
		setTimeout(function(){
			dataLockGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var dataLockGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},								
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'lock',					
					'class': 'spacer-toolbar-item',		
					disabled: true,
					permissions: ['AUTOUNIT_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:lock', ' Lock')						
					],
					listeners: {
						click: function() {
							actionUpdateLock(grid.selectedItems[0], true);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'unlock',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['AUTOUNIT_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:unlock', ' Unlock')						
					],
					listeners: {
						click: function() {
							actionUpdateLock(grid.selectedItems[0], false);
						}
					}					
				},
				{
					tag: 'dl-action-button',									
					itemid: 'history',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['AUTOUNIT_MANAGEMENT:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:list', ' View History')
					],
					listeners: {
						click: function() {
							actionHistory(grid.selectedItems[0]);
						}
					}
				}		
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [					
				{						
					path: 'lockMonth',
					header: 'Month',
					'text-align': 'center',
					width: '5em'
				},
				{						
					path: 'lockYear',
					header: 'Year',
					'text-align': 'center',
					width: '5em'
				},
				{						
					path: 'locked',
					header: 'Current Lock Status',
					'text-align': 'center',
					width: '5em',
					renderer: function(root, column, rowData) {
						if (rowData.item.locked) {
							root.style.backgroundColor = '';
							root.innerHTML = '<vaadin-icon icon="vaadin:lock"></vaadin-icon> Locked';							
								} else {
									root.style.backgroundColor = '#4bb64b';
									root.innerHTML = '<vaadin-icon icon="vaadin:unlock"></vaadin-icon> Open';
								}
					}
				},
				{						
					path: 'comment',
					header: 'Comment',					
					width: '16em',
					'flex-grow': 1
				},
				{						
					path: 'minutesUntilExpire',
					header: 'Open Expiration',					
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.minutesUntilExpire && !rowData.item.locked) {
							var createDate = TimeUtil.parseDate(rowData.item.createDts).valueOf();
							createDate = createDate + (rowData.item.minutesUntilExpire*60000);
							root.innerHTML = TimeUtil.formatDateStandard(new Date(createDate));			
						} else {
							root.innerHTML = '';
						}							
					}
				},
				{						
					path: 'createDts',
					header: 'Create Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.createDts) {
							var date = TimeUtil.parseDate(rowData.item.createDts);												
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = 'N/A';
						}
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					
					if (grid.selectedItems.length > 0) {
						if (grid.selectedItems[0].locked) {
							ElementUtil.query(toolbar, 'unlock').disabled = false;
							ElementUtil.query(toolbar, 'lock').disabled = true;
						} else {
							ElementUtil.query(toolbar, 'unlock').disabled = true;
							ElementUtil.query(toolbar, 'lock').disabled = false;
						}
						ElementUtil.query(toolbar, 'history').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'lock').disabled = true;
						ElementUtil.query(toolbar, 'unlock').disabled = true;
						ElementUtil.query(toolbar, 'history').disabled = true;
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		dataLockGrid.append(flexLayout);						
		
		var actionRefresh = function() {
			DataManagementService.getDataLockService().getDataLocks().then(function(locks){
				grid.activeItem = null;
				grid.items = locks.data;	
			});
		};
		actionRefresh();
		
		var actionUpdateLock = function(record, lock) {
			var lockWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: lock ? 'Lock Time Period' : 'Unlock Time Period',
				icon:  lock ? 'vaadin:lock' : 'vaadin:unlock',				
				width: 500,
				height: 300,
				listeners: {
					ready: function() {						
						lockWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'comment',
											label: 'Comment',
											required: true,
											colspan: 2,
											maxLength: 255											
										},
										{
											tag: 'vaadin-number-field',										
											name: 'minutesUntilExpire',
											label: 'Expires In',
											colspan: 2,
											value: 1,
											required: true,
											'class': (lock ? 'hide' : ''),
											min: 1,
											max: (365*1440)
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'timeUOMCB',
											name: 'timeUOM',
											label: 'Time Units',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: 'DAYS',
											'class': (lock ? 'hide' : ''),
											postinit: function (combo) {
												var units = [
													{ code: 'MINUTES', description: 'Minutes' },
													{ code: 'HOURS', description: 'Hours' },
													{ code: 'DAYS', description: 'Days' },
													{ code: 'MONTHS', description: 'Months' }
												];
												combo.items = units;
											},
											placeHolder: 'Select'
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon((lock ? 'vaadin:lock' : 'vaadin:unlock'), ' ' + (lock ? 'Lock' : 'Unlock'))
													],
													listeners: {
														click: function() {															
																												
															formPanel.submitForm({
																preSubmit: function(data) {	
																	if (!lock) {
																		var timeUnit = ElementUtil.query(formPanel, 'timeUOMCB').value;
																		if (timeUnit === 'HOURS') {
																			data.minutesUntilExpire = data.minutesUntilExpire * 60;
																		} else if (timeUnit === 'DAYS') {
																			data.minutesUntilExpire = data.minutesUntilExpire * 1440;
																		} else if (timeUnit === 'MONTHS') {
																			data.minutesUntilExpire = data.minutesUntilExpire * 43800;
																		}																		
																	}																	
																	return data;
																},
																actualCall: function(data) {			
																	
																	data.lockMonth = record.lockMonth;
																	data.lockYear = record.lockYear;
																	
																	if (lock) {
																		return DataManagementService.getDataLockService().createLock(data);
																	} else {
																		return DataManagementService.getDataLockService().createUnlock(data);
																	}																																		
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved ' + (lock ? 'Lock' : 'Unlock'), {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	lockWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															lockWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						lockWin.addToContentElement(formPanel);
					}
				}
			});	
		};
		
		var actionHistory = function(record) {
			var historyWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Lock History - Period: ' + record.lockMonth + "-" + record.lockYear,
				icon:  'vaadin:list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						historyWin.show();
						
						var historyGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [								
								{
									path: 'locked',
									header: 'Lock Status',
									'text-align': 'center',
									width: '5em',
									renderer: function (root, column, rowData) {
										if (rowData.item.locked) {
											root.style.backgroundColor = '';
											root.innerHTML = '<vaadin-icon icon="vaadin:lock"></vaadin-icon> Locked';
								} else {
									root.style.backgroundColor = '#4bb64b';
									root.innerHTML = '<vaadin-icon icon="vaadin:unlock"></vaadin-icon> Open';
								}
									}
								},
								{
									path: 'comment',
									header: 'Comment',
									width: '16em',
									'flex-grow': 1
								},								
								{
									path: 'createDts',
									header: 'Create Date',
									direction: 'desc',
									width: '7em',
									renderer: function (root, column, rowData) {
										if (rowData.item.createDts) {
											var date = TimeUtil.parseDate(rowData.item.createDts);
											root.innerHTML = TimeUtil.formatDateStandard(date);
										} else {
											root.innerHTML = 'N/A';
										}
									}
								},
								{
									path: 'updateUser',
									header: 'Update User',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									historyGrid.selectedItems = item ? [item] : [];
								}
							}
						});
						
						var actionRefreshHistory = function() {
							
							DataManagementService.getDataLockService().getDataLockHistory(record.lockMonth, record.lockYear).then(function (lockHistory) {
								historyGrid.activeItem = null;
								historyGrid.items = lockHistory;
							});							
						};
						actionRefreshHistory();
						
						historyWin.addToContentElement(historyGrid);
					}
				}
			});
			
		};		

	}
	
}
customElements.define('dl-datalock-grid', DataLockGrid);
